import {apiClient, FetcherSettings} from './apiClient';
import {Guidebook, PaginatedV2} from '../utils/types';

class GuidebooksApi {
  ENDPOINTS = {
    all: (reservationId: string) =>
      `api/v3/documents-v2/guidebooks/reservations/${reservationId}/`,
    guidebook: (guidebookId: string, reservationId: string) =>
      `api/v3/documents-v2/guidebooks/${guidebookId}/reservations/${reservationId}/`,
    group: (groupId: string) =>
      `api/v3/documents-v2/guidebook-groups/${groupId}/guidebooks/`,
  };

  async getGuidebooks<T = PaginatedV2<Guidebook>>(
    reservationId: string,
    fetcherSettings?: FetcherSettings,
  ) {
    const response = await apiClient.get<T>(
      this.ENDPOINTS.all(reservationId),
      fetcherSettings,
    );
    return response.body;
  }

  async getGuidebook(
    guidebookId: string,
    reservationId: string,
    fetcherSettings?: FetcherSettings,
  ) {
    const response = await apiClient.get<Guidebook>(
      this.ENDPOINTS.guidebook(guidebookId, reservationId),
      fetcherSettings,
    );
    return response.body;
  }

  async getGuidebooksByGroup(groupId: string, fetcherSettings?: FetcherSettings) {
    const response = await apiClient.get<Guidebook[]>(
      this.ENDPOINTS.group(groupId),
      fetcherSettings,
    );
    return response.body;
  }
}

export {GuidebooksApi};
